import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
var SET_SHARED_ENV = 'SET_SHARED_ENV';
export default SET_SHARED_ENV;